import { render } from "./PlaceHolderImage.vue?vue&type=template&id=204f6bc3"
import script from "./PlaceHolderImage.vue?vue&type=script&lang=js"
export * from "./PlaceHolderImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__